import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

const PILLARS = [
  { title: "Fiabilité", text: "Des engagements réalistes et tenus." },
  { title: "Rigueur", text: "Une méthode structurée à chaque étape." },
  { title: "Réactivité", text: "Des réponses rapides et des décisions claires." },
  { title: "Qualité d’exécution", text: "Des ouvrages conçus pour durer." },
];

export const APropos = () => (
  <section id="a-propos" data-testid="apropos-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-24">
        <SectionHeading
          chapter="05 — À propos"
          title="LIMEN, une autre manière d’aborder le chantier."
          testId="apropos"
        />
        <Reveal delay={0.15} className="flex flex-col justify-end gap-6 pb-2">
          <p className="text-base md:text-lg leading-relaxed text-anthracite/80" data-testid="apropos-text">
            Nous sommes convaincus qu’un chantier réussi commence bien avant le premier coup de vis.
          </p>
          <p className="text-base leading-relaxed text-anthracite/70">
            La qualité du résultat dépend autant de l’exécution que de la préparation, de l’organisation
            et de la communication.
          </p>
          <p className="text-base leading-relaxed text-anthracite/70">
            LIMEN a été créée autour d’une ambition simple : proposer une entreprise de rénovation
            intérieure fiable, structurée et attentive à la qualité de chaque ouvrage.
          </p>
          <p className="border-l-2 border-sable pl-5 font-heading text-base font-semibold text-nuit" data-testid="apropos-motto">
            Faire peu de promesses. Les tenir toutes.
          </p>
        </Reveal>
      </div>

      <div className="mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.08}>
            <div data-testid={`pillar-${i + 1}`} className="border-t-2 border-nuit pt-6 group">
              <span className="font-heading text-xs font-semibold tracking-[0.24em] text-sable-deep">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="mt-3 font-accent text-sm font-medium tracking-[0.18em] uppercase text-nuit">
                {p.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-anthracite/70">{p.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
